import React from 'react';

class CrossRectSVG extends React.Component {
  render () {
    return (
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="message" className="svg-inline--fa " role="img" 
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={this.props.style ? this.props.style : undefined}>
          <path fill="currentColor" d="M0,0v353.3h545.8V0H0z M512.5,320H33.3V33.3h479.3V320z"/>
          <path fill="currentColor" d="M217,120.8c-6.5,6.5-6.5,17,0,23.4l32.4,32.4L217,209c-6.5,6.5-6.5,17,0,23.4c6.5,6.4,17,6.5,23.4,0l32.4-32.4l32.4,32.4
            c6.5,6.5,17,6.5,23.4,0c6.4-6.5,6.5-17,0-23.4l-32.4-32.4l32.4-32.4c6.5-6.5,6.5-17,0-23.4s-17-6.5-23.4,0l-32.4,32.4l-32.4-32.4
            C233.9,114.3,223.4,114.3,217,120.8z"/>
      </svg>
    );
  }
}

export default CrossRectSVG;